import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "@activecollab/components";
import moment from "moment";
import PropTypes from "prop-types";
import { getPersonalizedDateFormat, getPersonalizedTimeFormat } from "~/store/selectors/selector.configOptions";
import Angie from "~/utils/angie.jsx";
import { useTickerContext } from "./Ticker/context";

const Ago = ({ timestamp, className, refresh = false }) => {
  const dateFormat = useSelector((state) => getPersonalizedDateFormat(state));
  const timeFormat = useSelector((state) => getPersonalizedTimeFormat(state));
  const timeFormatForTooltip = timeFormat === "hh:mm A" ? "h:mm A" : "HH:mm";
  const { now } = useTickerContext();
  const title = moment.unix(timestamp).format(dateFormat + " " + timeFormatForTooltip);
  const [formattedDate, setFormattedDate] = useState(Angie.functions.ago(timestamp, timeFormat, dateFormat));

  useEffect(() => {
    if (refresh && now > 0) {
      setFormattedDate(Angie.functions.ago(timestamp, timeFormat, dateFormat));
    }
  }, [dateFormat, now, refresh, timeFormat, timestamp]);

  return (
    <Tooltip
      title={title}
      className={className}
    >
      <span>{formattedDate}</span>
    </Tooltip>
  );
};

Ago.propTypes = {
  timestamp: PropTypes.number,
  className: PropTypes.string,
  refresh: PropTypes.bool,
};

Ago.defaultProps = {
  timestamp: 0,
  refresh: false,
};

export default Ago;
